// extracted by mini-css-extract-plugin
export default {"reasonInputLabel":"SingleSelect_reasonInputLabel__3gsCP","reasonForChangeField":"SingleSelect_reasonForChangeField__N4lZ6"};